export default function ({store, redirect}) {
	if (!store.state.user.uid) {
		let path = store.state.locale === 'zh_CN' ? '/' : '/en'
		return redirect(path)
	}
}